import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
import Repository from '@/app/repositories/repository'

import mainCategories from "../data/mainCategories.json";
import tree from "../data/tree.json";


const categoryRepository = RepositoryFactory.get('category');

export default Object.assign(categoryRepository, {
    // getMainCategories: function(){
    //     return Repository.get(`/category/getMainCategories`);
    // },
    getMainCategories: function () {
    return Promise.resolve({
      data: mainCategories
    });
  },
    getTree: function(categoryId){
        // return categoryId ? Repository.get(`/category/getTree?categoryId=${categoryId}`) : Repository.get(`/category/getTree`);
        if (categoryId){
            return Promise.resolve({
              data: tree.filter(e=>e.id === categoryId),
            });
        }
        return Promise.resolve({
              data: tree,
            });
    },
    getBySlug: function(slug){
        return Repository.get(`${this.resource}/getBySlug?slug=${slug}`);
    },
    getCategoryById: function(categoryId){
      let allTreeCategories = tree.map(e=>e.children);
      let allFlatTreeCategories = allTreeCategories.flatMap(e=>e);
      let categoryEntity = allFlatTreeCategories.find(e=>e.id===categoryId);

      return Promise.resolve({
        data: categoryEntity,
      });
    },
});
